import request from '@/utils/request'

// 生产环境api路径
// 获取专家成果列表
export function getQueryAcademicStats (data) {
  return request({
    url: '/old/api/queryAcademicStats',
    method: 'POST',
    data
  })
}

// 开发环境

// // 获取专家成果列表
// export function getQueryAcademicStats (data) {
//   return request({
//     url: '/api/api/queryAcademicStats',
//     method: 'POST',
//     data
//   })
// }



// WEBPACK FOOTER //
// ./src/api/retrieveName.js